
export class TaskProcessObject {

  constructor(private id: string, private forName: string, private domain: string, private operation: string, private errorCode: string, private errorDescription: string) {
  }

  public getId(): string {
    return this.id;
  }

  public getForName(): string {
    return this.forName;
  }

  public getOperation(): string {
    return this.operation;
  }

  public getErrorCode(): string {
    return this.errorCode;
  }

  public getErrorDescription(): string {
    return this.errorDescription;
  }

}
